module.exports = __webpack_public_path__ + "static/media/claims-center-bg.ddb438b0.jpg";